import React from 'react';
import './LocationModal.css';

const LocationModal = ({ isOpen, onClose, location }) => {
  if (!isOpen || !location) return null;

  // Mock contact data for each location
  const getContactInfo = (locationName) => {
    const contactData = {
      "Ampara Campus": {
        address: "123 Main Street, Ampara, Eastern Province, Sri Lanka",
        phones: ["+94 67 123 4567"],
        email: "ampara@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Anuradhapura Campus": {
        address: "456 Temple Road, Anuradhapura, North Central Province, Sri Lanka",
        phones: ["070 164 3884", "072 690 8792"],
        email: "anuradhapura@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Bandarawela Campus": {
        address: "789 Hill Street, Bandarawela, Uva Province, Sri Lanka",
        phones: ["070 372 2490", "074 098 1303"],
        email: "bandarawela@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Chilaw Campus": {
        address: "321 Beach Road, Chilaw, North Western Province, Sri Lanka",
        phones: ["+94 32 456 7890"],
        email: "chilaw@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Galle Campus": {
        address: "654 Fort Road, Galle, Southern Province, Sri Lanka",
        phones: ["+94 91 567 8901"],
        email: "galle@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Hambantota Campus": {
        address: "987 Southern Highway, Hambantota, Southern Province, Sri Lanka",
        phones: ["+94 47 678 9012"],
        email: "hambantota@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Island Wide Coverage": {
        address: "Multiple locations across Sri Lanka",
        phones: ["+94 11 789 0123"],
        email: "info@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Jaffna Campus": {
        address: "147 Northern Road, Jaffna, Northern Province, Sri Lanka",
        phones: ["Contact number coming soon"],
        email: "jaffna@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Kalutara Campus": {
        address: "258 Coastal Drive, Kalutara, Western Province, Sri Lanka",
        phones: ["+94 34 901 2345"],
        email: "kalutara@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Kandy Campus": {
        address: "369 Lake View Road, Kandy, Central Province, Sri Lanka",
        phones: ["076 999 8889", "072 260 4477", "072 928 3616"],
        email: "kandy@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Kegalle Campus": {
        address: "741 Central Street, Kegalle, Sabaragamuwa Province, Sri Lanka",
        phones: ["Contact number coming soon"],
        email: "kegalle@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Kiribathgoda Campus": {
        address: "852 Suburban Road, Kiribathgoda, Western Province, Sri Lanka",
        phones: ["+94 11 234 5678"],
        email: "kiribathgoda@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Kurunegala Campus": {
        address: "963 Northwestern Avenue, Kurunegala, North Western Province, Sri Lanka",
        phones: ["Contact number coming soon"],
        email: "kurunegala@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Mahiyanganaya Campus": {
        address: "159 Rural Road, Mahiyanganaya, Uva Province, Sri Lanka",
        phones: ["+94 55 456 7890"],
        email: "mahiyanganaya@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Matale Campus": {
        address: "753 Hill Country Road, Matale, Central Province, Sri Lanka",
        phones: ["+94 66 567 8901"],
        email: "matale@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Matara Campus": {
        address: "486 Southern Coast Road, Matara, Southern Province, Sri Lanka",
        phones: ["Contact number coming soon"],
        email: "matara@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Monaragala Campus": {
        address: "297 Uva Province Road, Monaragala, Uva Province, Sri Lanka",
        phones: ["Contact number coming soon"],
        email: "monaragala@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Nugegoda Campus": {
        address: "864 Main Suburban Road, Nugegoda, Western Province, Sri Lanka",
        phones: ["Contact number coming soon"],
        email: "nugegoda@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Polonnaruwa Campus": {
        address: "531 Ancient City Road, Polonnaruwa, North Central Province, Sri Lanka",
        phones: ["Contact number coming soon"],
        email: "polonnaruwa@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      },
      "Ratnapura Campus": {
        address: "742 Gem City Road, Ratnapura, Sabaragamuwa Province, Sri Lanka",
        phones: ["070 490 7312", "076 690 5379"],
        email: "ratnapura@sdit.edu.lk",
        hours: "Monday - Friday: 8:00 AM - 6:00 PM"
      }
    };

    return contactData[locationName] || {
      address: "Address information coming soon",
      phones: ["+94 11 123 4567"],
      email: "info@sdit.edu.lk",
      hours: "Monday - Friday: 8:00 AM - 6:00 PM"
    };
  };

  const contactInfo = getContactInfo(location.name);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{location.name}</h2>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <div className="location-image-section">
            <img 
              src={location.image} 
              alt={location.name}
              className="modal-location-image"
            />
          </div>
          
          <div className="location-details">
            <p className="location-description">{location.description}</p>
            
            <div className="contact-info">
              <h3>Contact Information</h3>
              
              <div className="info-item">
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <strong>Address:</strong>
                  <p>{contactInfo.address}</p>
                </div>
              </div>
              
              {contactInfo.phones && (
                <div className="info-item">
                  <i className="fas fa-phone"></i>
                  <div>
                    <strong>Phone:</strong>
                    {contactInfo.phones.map((phone) => (
                      <p key={phone}>{phone}</p>
                    ))}
                  </div>
                </div>
              )}
              
              <div className="info-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <strong>Email:</strong>
                  <p>{contactInfo.email}</p>
                </div>
              </div>
              
              <div className="info-item">
                <i className="fas fa-clock"></i>
                <div>
                  <strong>Operating Hours:</strong>
                  <p>{contactInfo.hours}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="modal-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationModal;
